import _ from "lodash";
import RowHeader from "./RowHeader";

const BreakSlot = ({ start, end, rooms }) => {
  const roomCount = _.keys(rooms).length;

  return (
    <>
      <tr>
        <RowHeader start={start} end={end} />
        <td className="break" colSpan={roomCount} rowSpan="3">
          BREAK
        </td>
      </tr>
      <tr />
      <tr />
    </>
  );
};

export default BreakSlot;
